"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllIosProducts = void 0;
var isAllIosProducts = function (basket) {
    var product_list = (basket || {}).product_list;
    if (product_list && product_list.length > 0) {
        return product_list.every(function (p) { var _a; return ((_a = p === null || p === void 0 ? void 0 : p.category) === null || _a === void 0 ? void 0 : _a._id) === process.env.IOS_CATEGORY_ID; });
    }
    return false;
};
exports.isAllIosProducts = isAllIosProducts;
